import React from "react"
import {Col, FormGroup, FormText, Input, Label} from "reactstrap";

export default class PasswordField extends React.Component {
  render() {
    return <FormGroup row>
      <Col>
        <Input size='sm' type="text" name={this.props.hash} id={this.props.hash} placeholder="Password.." />
        <FormText color="muted">Path: {this.props.filename}</FormText>
        <FormText color="muted">Hash: {this.props.hash}</FormText>
      </Col>
    </FormGroup>
  }
}


// WEBPACK FOOTER //
// ./src/components/Verification/PasswordField.js